import React from 'react'
import "./Home.css"
import ReferralForm from '../../components/ReferralForm'

export default function Home() {
  return (
    <div className="home">
      <ReferralForm />
    </div>
  )
}
